export default __webpack_public_path__ + "static/media/SPAIN-flag.59a2b2a9.png";